import { EmotionIcon } from '@hotjar/webapp/features/Feedback/EmotionIcon';
import { StarIcon } from '@hotjar/webapp/features/Feedback/EmotionIcon/icons/StarIcon';
import type { EmotionStyle, EmotionScore } from '@hotjar/insights-common/constants/emotions';

export const getFeedbackEmotionIcon = (
  emotionStyle: EmotionStyle,
  score: EmotionScore,
): JSX.Element => {
  return emotionStyle !== 'star' ? (
    <EmotionIcon score={score} emotionStyle={emotionStyle} size="s" />
  ) : (
    <StarIcon index={5} size={18} isOn />
  );
};
